import callApi from './customMemberService';

const basePath = '/api/Member';

export const updateMemberCardInfo = (updateInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/updateMemberCardInfo`,
  body: updateInfo
});
